import React from "react";
import Sidebar from "../components/Sidebar";
import achalLogo from "../assets/images/achal_logo.png";
import { 
  FiArrowLeft, FiSmartphone, FiCpu, FiUsers, FiCheckCircle, 
  FiMail, FiPhone, FiGlobe, FiMessageCircle, FiDownload 
} from "react-icons/fi";
import { FaAndroid, FaApple } from "react-icons/fa";

const About = () => {
  const systemWorkflow = [
    { title: "User Request", desc: "Employees raise tickets for workplace issues via Mobile/Web.", icon: <FiSmartphone /> },
    { title: "HOD Management", desc: "HODs oversee department tickets, assign workers, and audit quality.", icon: <FiUsers /> },
    { title: "Technical Resolution", desc: "Dedicated workers resolve tasks and update status in real-time.", icon: <FiCpu /> },
    { title: "Admin Control", desc: "Super Admin manages categories, HOD mappings, and overall system health.", icon: <FiCheckCircle /> },
  ];

  const handleWhatsApp = () => window.open("https://wa.me/919313118267", "_blank");
  const handleCall = () => window.location.href = "tel:+919313118267";

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.mainContent}>
        
        {/* --- HEADER --- */}
        <div style={styles.header}>
          <button onClick={() => window.history.back()} style={styles.backBtn}><FiArrowLeft /> Back</button>
          <img src={achalLogo} alt="Achal" style={styles.topLogo} />
        </div>

        <div style={styles.container}>
          {/* --- INTRO SECTION --- */}
          <section style={styles.section}>
            <h1 style={styles.mainTitle}>Achal Jewels Support System</h1>
            <p style={styles.version}>Enterprise Version 1.0.0 (Stable)</p>
            <p style={styles.description}>
              This system is a comprehensive digital bridge designed for Achal Jewels to streamline internal logistics, 
              maintenance, and technical tracking. From raising a ticket to final HOD audit, every step is optimized 
              for speed and transparency.
            </p>
          </section>

          {/* --- WORKFLOW GRID --- */}
          <div style={styles.workflowGrid}>
            {systemWorkflow.map((item, i) => (
              <div key={i} style={styles.workflowCard}>
                <div style={styles.workIcon}>{item.icon}</div>
                <h4 style={styles.workTitle}>{item.title}</h4>
                <p style={styles.workDesc}>{item.desc}</p>
              </div>
            ))}
          </div>

          {/* --- MOBILE APP DOWNLOAD --- */}
          <section style={styles.appSection}>
            <div style={styles.appInfo}>
              <h2 style={{ color: '#1E293B', margin: 0 }}>Achal Jewels on the Go</h2>
              <p style={{ color: '#64748B' }}>HODs and Admins can manage the entire workforce from their smartphones.</p>
            </div>
            <div style={styles.downloadGroup}>
<button 
  style={styles.downloadBtn} 
  onClick={() => window.open("https://ajplservices.tech/downloads/achal-support.apk", "_blank")}
>
  <FaAndroid size={20} /> 
  <div>
    <span>Download for</span>
    <strong>Android</strong>
  </div>
</button>
              <button style={{ ...styles.downloadBtn, background: '#000' }} onClick={() => alert("Version not found for iOS")}>
                <FaApple size={20} /> <div><span>Download for</span><strong>iOS / iPhone</strong></div>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

/* --- 💎 PROFESSIONAL STYLES --- */
const styles = {
  layout: { display: "flex", background: "#F8FAFC", minHeight: "100vh" },
  mainContent: { marginLeft: "260px", padding: "0", flex: 1, fontFamily: "'Inter', sans-serif" },
  header: { background: '#FFF', padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #E2E8F0' },
  backBtn: { background: '#F1F5F9', border: 'none', padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', color: '#475569' },
  topLogo: { height: '50px' },
  
  container: { maxWidth: '1000px', margin: '0 auto', padding: '50px 20px' },
  section: { textAlign: 'center', marginBottom: '60px' },
  mainTitle: { fontSize: '36px', fontWeight: '900', color: '#1E293B', margin: 0 },
  version: { color: '#D4AF37', fontWeight: '800', fontSize: '14px', letterSpacing: '2px', marginTop: '10px' },
  description: { color: '#64748B', fontSize: '16px', lineHeight: '1.8', maxWidth: '800px', margin: '25px auto' },

  workflowGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', marginBottom: '80px' },
  workflowCard: { background: '#FFF', padding: '30px', borderRadius: '24px', textAlign: 'center', border: '1px solid #F1F5F9', boxShadow: '0 10px 30px rgba(0,0,0,0.02)' },
  workIcon: { fontSize: '24px', color: '#D4AF37', background: '#FDFCF6', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto' },
  workTitle: { color: '#1E293B', fontWeight: '800', marginBottom: '10px' },
  workDesc: { color: '#94A3B8', fontSize: '13px', lineHeight: '1.5' },

  appSection: { background: '#FFF', padding: '40px', borderRadius: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '80px', border: '1px solid #E2E8F0' },
  downloadGroup: { display: 'flex', gap: '15px' },
  downloadBtn: { background: '#1E293B', color: '#FFF', border: 'none', padding: '12px 25px', borderRadius: '15px', display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', textAlign: 'left', span: { display: 'block', fontSize: '10px', opacity: 0.7 }, strong: { fontSize: '15px' } },

  craftedBy: { fontSize: '11px', fontWeight: '900', color: '#94A3B8', letterSpacing: '3px' },
  devLogo: { height: '60px', margin: '20px 0' },
  devText: { color: '#64748B', fontSize: '14px', maxWidth: '600px', margin: '0 auto 40px auto', lineHeight: '1.6' },
  
  contactGrid: { display: 'flex', gap: '15px', justifyContent: 'center', marginBottom: '40px' },
  contactCard: { background: '#F8FAFC', padding: '15px 25px', borderRadius: '18px', display: 'flex', alignItems: 'center', gap: '12px', fontWeight: '700', fontSize: '14px', cursor: 'pointer', border: '1px solid #E2E8F0', color: '#1E293B' },
  webLink: { display: 'inline-flex', alignItems: 'center', gap: '10px', color: '#D4AF37', textDecoration: 'none', fontWeight: '800', fontSize: '15px' }
};

export default About;